†<template>
  <div>
    <div class="header">
      <h1>State-by-State COVID changes</h1>
      <div class="date-info" v-if="date">
        <h2>{{ date }}</h2>
      </div>
      <div id="loading" v-if="!dataLoaded" v-html="loadingHTML"></div>

    </div>

    <main>
      <div class="main-primary">
        <div class="map-container" :id="mapid">
          <div class="map"></div>
        </div>
      </div>

      <div class="main-secondary">
        <div class="controls" v-if="dataLoaded">
          <div class="slider" v-if="dataLoaded" ref="slider">
             <input type="range" ref="slidermax" @input="changeMaxDate" @change="changeMaxDate" :min="minTimestamp" step="86400000" v-bind:max="todayTimestamp"  :value="dateTimestamp" id="date">
             <input type="range" ref="slidermin" :min="minTimestamp" @input="changeMinDate" @change="changeMinDate" step="86400000" v-bind:max="todayTimestamp"  :value="beforeTimestamp" id="datebefore">
          </div>
          <div class="compareRange">
            <p>Compare with: <br />
              <input type="radio" name="compareRange" value="7" v-model="compareDays" id="compare1" /><label for="compare1">One Week</label>
              <input type="radio" name="compareRange" value="14" v-model="compareDays" id="compare2" /><label for="compare2">Two Weeks</label>
              <input type="radio" name="compareRange" value="21" v-model="compareDays" id="compare3" /><label for="compare3">Three Weeks</label>
              <br />
              <input type="text" size="3" v-model="compareDays" /> Days before
            </p>
          </div>
          <button @click="animate">Animate</button><br />
          Speed (time between dates in ms): <input type="number" v-model="animationSpeed" />
          <div v-if="better">

            <span><b>Better:</b> {{ better }}  </span>
            <span><b>Worse:</b> {{ worse }}</span>
          </div>

        </div>
        <div v-if="activeState">
          <h3 style="text-align: left">{{ activeState.name }}</h3>

          <table>
            <tr>
              <th>Date</th><th>New Cases</th>
            </tr>
            <tr v-for="d in activeState.data" :key="d.date">
              <td>{{ d.date }}</td><td>{{ d.newcases }}</td>
            </tr>
          </table>
        </div>
      </div>
    </main>
    <footer v-if="dataLoaded">
      Notes:
      <ul>
        <li>Change in rolling weekly average, 2 weeks ago to today. Red = more new cases, green = fewer, shading represents magnitude</li>
        <li>Data from <a href="https://covidtracking.com/data/api" target="_blank">https://covidtracking.com/data/api</a> using Positive Increase, and ignoring null or negative numbers</li>
      </ul>
    </footer>
  </div>
</template>

<script>
  import * as d3 from "d3";
  import { format, subDays, parse, isBefore, isAfter, addDays, getTime }  from "date-fns";

  export default {
    data () {
      return {
        dataLoaded: false,
        loadingHTML: 'Loading.....',
        mapDrawn: false,
        mapid: 'map_' + this.makeid(),
        path: null,
        width: 960,
        height: 500,
        data: null,
        before: null,
        better: null,
        worse: null,
        today: null,
        animationSpeed: 300,
        animateInterval: false,
        daysBefore: 14,
        twoweeksago: null,
        oneweekago: null,
        threeweeksago: null,
        date: null,
        d: {
          today: {},
          todayavg: {},
          todaytot: {},
          todaynum: {},
          beforeavg: {},
          beforetot: {},
          beforenum: {},
          daily: {},
          difference: {},
          stateData: {},

        },
        activeState: null,
        timestampDifference: 1209600000,
        compareDays: 14
      }
    },
    computed: {
      title () {
        return 'Change in rolling weekly average, 2 weeks ago to today. Red = more new cases, green = fewer, shading represents magnitude';
      },
      todayTimestamp () {
        if (this.today) {
          return  this.timestampFromString(this.today);
        } else {return this.today}

      },
      beforeTimestamp () {
        if (this.before) {
          return  this.timestampFromString(this.before);
        } else {return this.before}
      },
      dateTimestamp () {
        if (this.today) {

          return this.timestampFromString(this.date);
        } else {return this.date}

      },
      minTimestamp () {
        return getTime(new Date(2020, 2, 31));
      },

    },
    watch: {
      compareDays: function(newDays) {
        let days = newDays;
        let $this = this;
        let newbefore = subDays(parse($this.today, 'yyyyMMdd', new Date()), days);

        //this.before = $this.stringFromTimestamp(newbefore);
        this.$set(this, 'before', $this.stringFromTimestamp(newbefore)*1);
        this.$set(this, 'daysBefore', days);
        this.$set(this, 'timestampDifference', days*86400000);
        this.changeDate();
      }
    },
    async mounted () {
      this.setProjection()
      await this.getData()
      this.loadingHTML = "Processing.....";

      await this.manipulateData()


      this.dataLoaded = true
      await this.drawMap();

      this.resetSlider();



      d3.select(window)
        .on("resize", this.scaleMap);


    },
    methods: {
      setProjection() {
        let $this = this
        var projection = d3.geoAlbers()
            .translate([$this.width/2, $this.height/2])    // translate to center of screen
            .scale([1000]);
       // Define path generator
       let path = d3.geoPath()               // path generator that will convert GeoJSON to SVG paths
                    .projection(projection);  // tell path generator to use albersUsa projection
       this.path = path;

      },
      makeid () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 10; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
      },
      scaleMap () {
        let m = document.getElementById(this.mapid).offsetWidth;
        //let svg = document.getElementsByTagName('svg');
        //d3.select("g").attr("transform", "scale(" + $("#" + this.mapid + " .map").width()/900 + ")");
        d3.select("g").attr("transform", "scale(" + m/900 + ")");
        //$("svg").height($("#map").width()*0.618);
        //svg[0].style.height = m*0.53;
        d3.select("svg").attr("height", m*0.53);

      },
      resetSlider () {
        let slider = this.$refs.slider;
        let $this = this;
        if (typeof slider !== 'undefined') {
          //console.log(slider.style.getProperty('--a'))
          slider.style.setProperty('--b', $this.dateTimestamp)
          slider.style.setProperty('--a', $this.dateTimestamp - $this.timestampDifference)
          slider.style.setProperty('--min', $this.minTimestamp)
          slider.style.setProperty('--max', $this.todayTimestamp)
        }
      },
      async drawMap() {
        let $this = this;

        if (!this.mapDrawn) {
          this.svg = d3.select("#" + this.mapid + " .map")
             .append("svg")
               .attr("width", "100%")
               .append("g")

             d3.json("/data/us-states.json")
              .then(function(json) {
                $this.svg.selectAll("path")
                  .data(json.features)
                  .enter()
                  .append("path")
                  .attr("d", $this.path)
                  .attr("class", 'state')

                  .style("fill", function(d) {
                     // Get data value

                      //var value = d.properties.viewed;
                      //return colorScale(value);
                      let abs = Math.abs($this.d.difference[d.properties.abbr]);
                      let opacity = abs / 50;
                      if (opacity > 1) {opacity = 1}
                      if (opacity == 0) {opacity = .1}
                      if ($this.d.difference[d.properties.abbr] >= 0) {
                        return 'rgba(255, 0, 0, ' + opacity + ')'
                      }
                      return 'rgba(0, 255, 0, ' + opacity + ')'
                  })
                  .on('click', function(d) {
                    //let states = document.getELementsByClass("activeState");
                    d3.select(this).attr("class", "state activeState");
                    $this.activeState = {};
                    $this.activeState.name = d.properties.name;
                    $this.activeState.data = $this.d.stateData[d.properties.abbr];
                  })
             });

        }
        else {

          this.svg.selectAll("path")
                //.data(json.features);

              this.svg.transition().selectAll("path")

                .style("fill", function(d) {
                  let abs = Math.abs($this.d.difference[d.properties.abbr]);
                  let opacity = abs / 50;
                  if (opacity > 1) {opacity = 1}
                  if (opacity == 0) {opacity = .1}
                  if ($this.d.difference[d.properties.abbr] >= 0) {
                    return 'rgba(255, 0, 0, ' + opacity + ')'
                  }
                  return 'rgba(0, 255, 0, ' + opacity + ')'
              })

        }

        this.scaleMap()
          this.mapDrawn = true;

      },
      async getData () {
        await fetch('https://api.covidtracking.com/v1/states/daily.json')
          .then(response => response.json())
          .then(data => this.data = data)
        return
      },
      async manipulateData () {
        this.loadingHTML = "Processing.....";
        let $this = this;
        if (this.data) {
          let count = 0;
          let ignore = ["AS", "GU", "MP", "PR", "VI"];
          for (let t of this.data) {
            if (!ignore.includes(t.state)) {
              if (count == 0) {
                $this.today = t.date
                $this.date = t.date
                $this.oneweekago = subDays(parse($this.today, 'yyyyMMdd', new Date()), 7);
                $this.twoweeksago = subDays(parse($this.today, 'yyyyMMdd', new Date()), 14);
                $this.threeweeksago = subDays(parse($this.today, 'yyyyMMdd', new Date()), 21);
                $this.before = $this.stringFromTimestamp($this.twoweeksago);
              }

              let positiveIncrease = t.positiveIncrease;
              if (!t.positiveIncrease || t.positiveIncrease*1 < 0) {
                positiveIncrease = false;
              }

              // capture the first date
              if (typeof this.d.daily[t.date] == "undefined") {
                this.d.daily[t.date] = {}
              }
              this.d.daily[t.date][t.state] = {}
              if (positiveIncrease) {
                this.d.daily[t.date][t.state]["new"] = positiveIncrease
                this.d.daily[t.date][t.state]["avg"] = positiveIncrease
                this.d.daily[t.date][t.state]["tot"] = positiveIncrease
                this.d.daily[t.date][t.state]["num"] = 1
              } else {
                this.d.daily[t.date][t.state]["new"] = 0
                this.d.daily[t.date][t.state]["avg"] = 0
                this.d.daily[t.date][t.state]["tot"] = 0
                this.d.daily[t.date][t.state]["num"] = 0
              }



              for (let i = 1; i < 7; i++) {
                let newdate = addDays(parse(t.date, 'yyyyMMdd', new Date()), i);
                newdate = format(newdate, "yyyyMMdd");
                if (newdate <= $this.today && positiveIncrease) {

                  this.d.daily[newdate][t.state]["tot"] += positiveIncrease
                  this.d.daily[newdate][t.state]["num"] += 1
                  this.d.daily[newdate][t.state]["avg"] = Math.round(this.d.daily[newdate][t.state]["tot"] / this.d.daily[newdate][t.state]["num"])
                }
              }


              if (t.date == $this.today) {
                if (positiveIncrease) {
                  this.d.today[t.state] = positiveIncrease
                  this.d.todayavg[t.state] = positiveIncrease
                  this.d.todaytot[t.state] = positiveIncrease
                  this.d.todaynum[t.state] = 1
                } else {
                  this.d.today[t.state] = 0
                  this.d.todayavg[t.state] = 0
                  this.d.todaytot[t.state] = 0
                  this.d.todaynum[t.state] = 0
                }

              }
              else if (isBefore($this.oneweekago, parse(t.date, 'yyyyMMdd', new Date())) && positiveIncrease) {
                this.d.todaytot[t.state] += positiveIncrease
                this.d.todaynum[t.state] += 1
                this.d.todayavg[t.state] = Math.round(this.d.todaytot[t.state] / this.d.todaynum[t.state])


              }
              else if (t.date == format($this.before, "yyyyMMdd")*1) {
                if (positiveIncrease) {
                  this.d.beforetot[t.state] = positiveIncrease
                  this.d.beforenum[t.state] = 1
                  this.d.beforeavg[t.state] = positiveIncrease
                } else {
                  this.d.beforetot[t.state] = 0
                  this.d.beforenum[t.state] = 0
                  this.d.beforeavg[t.state] = 0
                }

              }
              else if (isBefore($this.threeweeksago, parse(t.date, 'yyyyMMdd', new Date())) && isAfter($this.before, parse(t.date, 'yyyyMMdd', new Date())) && positiveIncrease) {
                this.d.beforetot[t.state] += positiveIncrease
                this.d.beforenum[t.state] += 1
                this.d.beforeavg[t.state] = Math.round(this.d.beforetot[t.state] / this.d.beforenum[t.state])
              }

              if (typeof this.d.stateData[t.state] == "undefined") {
                this.d.stateData[t.state] = {}
              }
              this.d.stateData[t.state][t.date] = {};
              this.d.stateData[t.state][t.date]["date"] = t.date
              this.d.stateData[t.state][t.date]["newcases"] = positiveIncrease

              count++;
            }


          }
          await this.countData()

        }
        return;

      },
      animate () {
        let i = this.minTimestamp + this.timestampDifference;
        let $this = this;
        if (this.animateInterval) {
          clearInterval($this.animateInterval);
        }
        this.animateInterval = setInterval(function() {
          $this.$refs.slidermax.value = i;
          $this.changeDate();
          if (i == $this.todayTimestamp) {
            clearInterval($this.animateInterval);
          }


          i = i + 86400000;
        }, $this.animationSpeed)
      },
      countData () {
        let better = 0;
        let worse = 0;
        let before = format(subDays(parse(this.date, 'yyyyMMdd', new Date()), this.daysBefore), "yyyyMMdd");
        for (let [state, obj] of Object.entries(this.d.daily[this.date])) {
          let difference = Math.round(((obj.avg - this.d.daily[before][state].avg) / this.d.daily[before][state].avg)*100);

          if (difference > 0) {worse++;}
          if (difference < 0) {better++;}
          this.$set(this.d.difference, state, difference);

        }
        this.better = better;
        this.worse = worse;

      },
      async changeMaxDate () {
        this.changeDate();
      },
      async changeMinDate () {
        let min = this.$refs.slidermin.value*1;
        let max = this.$refs.slidermax.value*1;
        let diff = max - min;
        let days = diff / 86400000;
        this.$set(this, 'compareDays', days);
        this.changeDate ();
      },
      async changeDate () {
        let timestamp = this.$refs.slidermax.value*1;

        this.date = this.stringFromTimestamp(timestamp)
        this.before = this.stringFromTimestamp(timestamp - this.timestampDifference)
        this.resetSlider();
        await this.countData();
        this.drawMap();

      },
      changingSlider () {

        console.log(this.$refs.slidermax.value);

      },
      timestampFromString (dateString) {
        dateString = dateString.toString();
        let year        = dateString.substr(0,4);
        let month       = dateString.substr(4,2);
        let day         = dateString.substr(6,2);
        return getTime(new Date(year, month-1, day));
      },
      stringFromTimestamp (timestamp) {
        let d = new Date(timestamp);
        return format(d, "yyyyMMdd")*1;
      }

   }



   // TODO: slider https://stackoverflow.com/questions/4753946/html5-slider-with-two-inputs-possible
}
</script>


<style lang="scss">

  :root {
    --mainColor: rgb(0, 255, 0);
    --mainDarker: rgb(34,139,34);
    --mainDarkest: rgb(9, 37, 9);
    --sliderColor: rgb(0, 255, 0);
    --highlightColor: rgba(255, 0, 0, 1);
    --highlightFaded: pink;

  }

  #loading {
    margin-top: 30px;
    font-size: 34px;
    font-weight: bold;
    color: var(--mainColor);
  }

  main {
    @media screen and (min-width: 1200px) {
      display: flex;
      > * {
        flex: 1;
      }
      .main-primary {
        flex: 2;
      }
    }
  }
  .main-secondary {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  footer {
    text-align: left;
    font-size: 12px;
  }


  .state {
    stroke: #fff;
    stroke-width: 1;
  }
  .state.active {
    stroke: blue;
    stroke-width: 3;
    z-index: 5;
  }


/* START BUTTONS */
  button {
    background-color: var(--mainDarker);
    color: white;
    font-weight: bold;
    padding: 5px 15px;
    border-radius: 5px;
    border: none;
    box-shadow: 0 2px var(--mainDarkest);
    outline: none;
    cursor: pointer;
    &:hover {
      background-color: var(--mainDarker);
    }
    &:active {
      box-shadow: 0 1px var(--mainDarkest);
      transform: translateY(1px);
    }
  }

/* END BUTTONS */


  /* START SLIDER */


  $w: 20em;
  $h: 1em;

  @mixin track() {
      width: 100%; height: 100%;
      background: none /* get rid of Firefox track background */
  }

  @mixin thumb() {
      border: none; /* get rid of Firefox thumb border */
      width: $h; height: $h;
      border-radius: 5px; /* get rid of Firefox corner rounding */
      background: var(--highlightColor);
      pointer-events: auto;
  }

  .slider {
    --max: 1000;
    --min: 500;
    --a: 500;
    --b: 1000;
     --dif: calc(var(--max) - var(--min));
    display: grid;
    /*
    grid-template: repeat(1, -webkit-max-content) 1em/ 1fr 1fr;
    grid-template: repeat(1, max-content) 1em/ 1fr 1fr;
    */
    overflow: hidden;
    position: relative;
    margin: 5px auto 10px;
    cursor: pointer;
    // box-shadow: 1px 1px 1px , 0px 0px 1px var(--mainDarker);
    background: var(--sliderColor);
    border-radius: 1.3px;
    // border: 0.2px solid #010101;
    outline: none;

    &::before, &::after {
      grid-column: 1/ span 2;
      grid-row: 3;
      height: 100%;
      background: var(--mainDarker);
      content: "";
      outline: none;
    }

    &::before {


      margin-left: calc((var(--a) - var(--min))/var(--dif)*100%);
      width: calc((var(--b) - var(--a))/var(--dif)*100%);
    }

    &::after {
      margin-left: calc((var(--b) - var(--min))/var(--dif)*100%);
      width: calc((var(--a) - var(--b))/var(--dif)*100%);
    }

    input[type='range'] {
      grid-column: 1/ span 2;
     grid-row: 3;
     z-index: 1;
     top: 0;
     left: 0;
     margin: 0;
     background: none;
     outline: none;
     /* get rid of white Chrome background */
     --col: #000;
     pointer-events: none;
    }
  }

  input[type='range'] {
    &::-webkit-slider-runnable-track,
    &::-webkit-slider-thumb, & { -webkit-appearance: none; }

    /* same as before */
    background: none; /* get rid of white Chrome background */
    color: var(--mainDarker);
    font: inherit; /* fix too small font-size in both Chrome & Firefox */
    margin: 0;
    pointer-events: none; /* let clicks pass through */


    &::-webkit-slider-runnable-track { @include track }
    &::-moz-range-track { @include track }

    &::-webkit-slider-thumb { @include thumb }
    &::-moz-range-thumb { @include thumb }
    &#datebefore {
      &::-webkit-slider-thumb { background: var(--highlightFaded); }
      &::-moz-range-thumb { background: var(--highlightFaded); }
    }
  }
/* END SLIDER */

</style>
